// Variables
const IS_HIDDEN_ATTRIBUTE = 'is-hidden';

/**
 * Hide / Show the topbar on scroll
 *  - Hide on scroll down if we have scrolled at least the same amount as the topbar height
 *  - Show on scroll up
 */
class TopbarHideOnScroll {
    constructor(topbarEl) {
        this.topbarEl = topbarEl;
        this.isHidden = false;
        this.threshold = this.topbarEl.offsetHeight;
        this.lastScrollPos = 0;

        window.addEventListener('scroll', this._handleScroll);
    }

    /**
     * Add / remove the attribute according to the current state
     * @param value
     */
    set isHidden(value) {
        this._isHidden = value;
        this._isHidden
            ? this.topbarEl.setAttribute(IS_HIDDEN_ATTRIBUTE, '')
            : this.topbarEl.removeAttribute(IS_HIDDEN_ATTRIBUTE);
    }

    /**
     * Get correct value for the current state
     * @returns {*}
     */
    get isHidden() {
        return this._isHidden;
    }

    /**
     * On scroll, check the scroll direction and set the state accordingly
     * @private
     */
    _handleScroll = () => {
        this.threshold = this.topbarEl.offsetHeight;
        const newScrollPos = window.pageYOffset || document.documentElement.scrollTop;
        this.isHidden = newScrollPos > this.lastScrollPos && newScrollPos > this.threshold;
        this.lastScrollPos = newScrollPos;
    }
}

/**
 * Wait for the page to load before running the custom script
 */
export function initTopbarHideOnScroll() {
    const topbarEl = document.querySelector('.topbar');
    if (!topbar) return;

    new TopbarHideOnScroll(topbarEl);
}